// removed by extract-text-webpack-plugin
module.exports = {"colored-background":"colored-background___2_G9c","coloredBackground":"colored-background___2_G9c","background":"background___2LOJs","full":"full___2bwi9","fit":"fit___2o5Jl"};